module.exports = __webpack_public_path__ + "static/media/s-form.45b9d14d.svg";